var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',_vm._l((_vm.data.tiles),function(tile,index){return _c('v-col',{key:index},[_c('v-card',{attrs:{"outlined":"","flat":""}},[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.formattedValue(tile.value))+" ")]),_c('v-card-subtitle',[_vm._v(" "+_vm._s(tile.label)+" ")])],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }